const incidents = (incidents = [], action) => {
  switch (action.type) {
    case 'FETCH_INCIDENTS':
      return action.payload
    default:
      return incidents
  }
}
export default incidents
